import ErrorIcon from '@mui/icons-material/Error';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import Colors from '../theme/colors';

interface DialogProps {
  open: boolean;
  onClose?: () => void;
  buttons?: ReactNode;
  error?: boolean;
  title?: string;
  subtitle?: string;
}

const ModalDialog: React.FC<PropsWithChildren<DialogProps>> = ({
  children,
  onClose,
  buttons,
  open,
  error,
  title,
  subtitle,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': { padding: '24px', paddingBottom: '16px', paddingLeft: error ? '72.5px' : undefined },
        '& .MuiBackdrop-root': {
          backgroundColor: Colors.transparentGray,
        },
        flexDirection: 'column',
        psoition: 'relative',
      }}
    >
      {error && (
        <ErrorIcon
          sx={{
            color: Colors.orange,
            height: '35px',
            width: '35px',
            position: 'absolute',
            top: '20px',
            left: '24px',
          }}
        />
      )}
      {title && (
        <DialogTitle
          sx={{
            padding: '0px',
            paddingBottom: '16px',
            '& .title': {
              fontWeight: 'bold',
              fontSize: '20px',
            },
            '& .subtitle': {
              fontSize: '17px',
              color: Colors.gray,
            },
          }}
        >
          <Typography className='title'>{title}</Typography>
          {subtitle && <Typography className='subtitle'>{subtitle}</Typography>}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          padding: '0px',
          paddingBottom: '24px',
        }}
      >
        {children}
      </DialogContent>
      {buttons && <DialogActions sx={{ gap: '12px', padding: '0px' }}>{buttons}</DialogActions>}
    </Dialog>
  );
};

export default ModalDialog;

export const DialogButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.main,
  height: '36px',
  padding: '0px 8px',
}));
